const PROPERTY_TYPE = {

  id: "property_type",
  type: "dropdown",
  props: {
    dropdownProps: {
      label: "Property Type",
      buttonProps: {
        className: "property_type",
      },
      menuProps: {
        style: {
          // minWidth: 300
        }
      }
    },
    options: [
      { label: "HDB", value: "HDB" },
      { label: "Private", value: "Private" },
      { label: "BUC", value: "BUC" },
    ]
  }

}

const COL_PROPERTY_TYPE = {

  id: "col_property_type",
  type: "col",
  props: {
    lg: 3,
    md: 4,
    xs: 6,
  },
  children: [PROPERTY_TYPE]

}

export { PROPERTY_TYPE, COL_PROPERTY_TYPE };
